








import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill';

@Component
export default class TestEditor extends Vue {
  //toolbar 配置网址： https://quilljs.com/docs/modules/toolbar/
  toolbarOptions: object = [
    ['bold', 'italic'],
    ['link', 'image'],
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }]
  ];
  editorOptions: object = {
    debug: 'info',
    modules: {
      toolbar: this.toolbarOptions
    },
    placeholder: 'Compose an epic...',
    readOnly: false,
    theme: 'snow'
  };

  editor?: Quill;
  contents?: String;
  value: string = '';

  mounted() {
    // 监听按钮事件但是会替换原来的事件
    this.editor = new Quill('#editorContainer', this.editorOptions);
    console.log(this.$props);
    this.editor.root.innerHTML = '<h1>222</h1>';
    var toolbar = this.editor.getModule('toolbar');
    toolbar.addHandler('image', this.showImageUI);
    var self = this;
    this.editor.on('text-change', function(delta, oldDelta, source) {
      self.$emit('input', self.editor!.root.innerHTML);
    });
  }

  /**上传图片的按钮点击 */
  showImageUI(val: any) {
    let input = document.getElementById('uploadButton');
    if (input != null) {
      input.click();
    }
  }

  /**选中了某张图片 */
  onSelectImage(value: any) {
    let url = value.target.value;
    console.log(`图片地址是${url}`);
    console.log('开始上传');
    var formData = new FormData();
    formData.append('image', url);
    console.log('上传完成');
    //图片上传成功之后的回调
    const range = this.editor!.getSelection();
    if (range) {
      this.editor!.insertEmbed(range.index, 'image', '' + `https://www.easyicon.net/api/resizeApi.php?id=26596&size=128`); //将上传好的图片，插入到富文本的range.index（当前光标处）
    }
  }
}
